(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tuumiist-support-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.extended-warranty__form').forEach(function(form){
  form.noValidate=true;
  var submitButton=form.querySelector('.extended-warranty__submit');
  var rules=[
    {key:'name',message:'Please enter your full name.'},
    {key:'order',message:'Please enter your order number.'},
    {key:'platform',message:'Please select your purchase platform.'},
    {key:'email',message:'Please enter your email address.'}
  ];
  function fieldFor(key){return form.querySelector('[data-field="'+key+'"]');}
  function clearError(key){
    var wrap=fieldFor(key);if(!wrap)return;
    var control=wrap.querySelector('input,select,textarea');
    var error=wrap.querySelector('.extended-warranty__error');
    if(control)control.removeAttribute('aria-invalid');
    if(error)error.hidden=true;
  }
  function showError(key,message){
    var wrap=fieldFor(key);if(!wrap)return null;
    var control=wrap.querySelector('input,select,textarea');
    var error=wrap.querySelector('.extended-warranty__error');
    if(control)control.setAttribute('aria-invalid','true');
    if(error){if(message)error.textContent=message;error.hidden=false;}
    return control;
  }
  form.addEventListener('submit',function(event){
    var firstInvalid=null;
    rules.forEach(function(rule){
      clearError(rule.key);
      var wrap=fieldFor(rule.key);
      var control=wrap&&wrap.querySelector('input,select');
      if(!control||!control.value.trim()){var invalid=showError(rule.key,rule.message);if(!firstInvalid)firstInvalid=invalid;}
    });
    clearError('email');
    var emailWrap=fieldFor('email');
    var email=emailWrap&&emailWrap.querySelector('input');
    if(email&&email.value.trim()&&email.validity.typeMismatch){var invalidEmail=showError('email','Please enter a valid email address.');if(!firstInvalid)firstInvalid=invalidEmail;}
    if(firstInvalid){event.preventDefault();firstInvalid.focus();return;}
    if(submitButton){submitButton.disabled=true;submitButton.setAttribute('aria-busy','true');}
  });
  form.querySelectorAll('input,select,textarea').forEach(function(control){
    ['input','change'].forEach(function(eventName){control.addEventListener(eventName,function(){var wrap=control.closest('[data-field]');if(wrap)clearError(wrap.getAttribute('data-field'));});});
  });
  var success=form.querySelector('.extended-warranty__success');if(success)success.focus();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuumiist-touch-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const feature = event.target.closest('.tta__feature');
    if (feature) feature.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
